import { useCallback, useEffect, useId } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { useMe } from '@entities/user/api';
import { AuthFlow, takePendingAction } from '@features/auth';
import { ROUTES } from '@shared/config/routes';
import { Container } from '@shared/ui';

import styles from './LoginPage.module.css';

/**
 * Страница входа для прямых заходов и закладок (`/login` из MVP_PRD §5).
 *
 * Использует тот же `AuthFlow`, что и модальное окно: два разных экрана входа
 * неизбежно разошлись бы в поведении.
 */
export function LoginPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const titleId = useId();
  const { data: session } = useMe();

  // Авторизованному здесь делать нечего.
  useEffect(() => {
    if (session) void navigate(ROUTES.app, { replace: true });
  }, [session, navigate]);

  const handleSuccess = useCallback(() => {
    const pending = takePendingAction();
    window.setTimeout(() => {
      void navigate(pending?.returnUrl ?? ROUTES.app, { replace: true });
    }, 900);
  }, [navigate]);

  return (
    <section className={styles.page}>
      <Container width="narrow" className={styles.inner}>
        {/* Та же карточка, что у модального окна: страница и диалог читаются
            как одна вещь (DESIGN_SYSTEM §5.2). */}
        <div className={styles.core}>
          <AuthFlow titleId={titleId} headingLevel="h1" onSuccess={handleSuccess} />
        </div>

        <p className={styles.aside}>{t('auth.page.aside')}</p>
      </Container>
    </section>
  );
}
